import React from 'react';
import AdminLayout from './components/adminlayout';
import RefundEdit from './components/editrefund';

const Refund = () => (
    <AdminLayout>
        <div className='p-6'>
            <div className='bg-white rounded-lg border border-gray-200 p-6'>
                <RefundEdit />
            </div>
        </div>
    </AdminLayout>
);
export default Refund;
